"use strict";

const Popout = () => {
    const init = () => {
        $(function() {
            var $popout = $('.js-popout');
            var $anchorPopup = $('a[href*="#"]');

            window.resetPopoutTriggers = function(){
                var $popoutTriggers = $('.js-popout-trigger');

                $popoutTriggers.off('click');
                $popoutTriggers.on('click', function(){
                    openPopout($(this).data('popout'));
                });

                $anchorPopup.off('click')
                $anchorPopup.on('click', function() {
                    var $hash = $(this).attr('href').replace('#', '')
                    openPopout($hash);
                })
            }

            window.openPopout = function($hash){
                $popout.removeClass('open');
                $popout.filter('.js-popout[data-hash="'+ $hash +'"]').addClass('open');
            }

            resetPopoutTriggers();

            $popout.find('.js-popout-close').on('click', function(){
                $popout.removeClass('open');
            });

            $popout.find('.js-popout-close-deny').on('click', function(){
                closePopout();
                GA.updateConsent($(this), 'denied');
            });

            $popout.find('.js-popout-close-accept').on('click', function(){
                closePopout();
                GA.updateConsent($(this), 'granted');
            });

            window.closePopout = function(){
                $('.js-popout').removeClass('open');
            };
        });
    };

    return {
        init:init
    };
};

export default Popout;